@if (control) {
  <mat-form-field appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <mat-select
      panelClass="app-ui-select"
      [hideSingleSelectionIndicator]="true"
      [formControl]="control"
      [multiple]="isMultiple"
      (selectionChange)="onChange($event)"
      (openedChange)="onPanelOpenedChange($event)"
      [value]="selected"
      [disabled]="disabled"
      [required]="required"
      [compareWith]="compareWith"
    >
      @if (enableSearch) {
        <input
          #searchInput
          (keyup)="$event.stopPropagation(); onSearch($event)"
          (keydown)="$event.stopPropagation()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
          placeholder="{{ 'search' | translate }}"
          class="mat-dropdown-select-input"
        />
      }
      @if (selectAll) {
        <mat-optgroup class="select-all-checkbox-row-group divider-bottom">
          <mat-checkbox
            class="mat-option select-all-row"
            color="primary"
            [ngClass]="{ 'mat-selected': areSomeRowsSelected || areAllRowsSelected }"
            [indeterminate]="areSomeRowsSelected"
            [checked]="areAllRowsSelected"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection($event)"
          >
            {{ 'selectAll' | translate }}
          </mat-checkbox>
        </mat-optgroup>
      }
      @for (group of displayedOptionGroups; track $index) {
        <mat-optgroup [label]="group.type | translate">
          <ng-container
            *ngTemplateOutlet="optionsTemplate; context: { $implicit: group }"
          ></ng-container>
        </mat-optgroup>
      }
      <ng-template #optionsTemplate let-group>
        @for (option of group.options; track option.id) {
          @if (returnWholeObject) {
            <mat-option [value]="{ value: option, type: group.type }">
              {{ option.name }}
            </mat-option>
          } @else {
            <mat-option [value]="option.id">
              {{ option.name }}
            </mat-option>
          }
        }
      </ng-template>
    </mat-select>
    @if (!control.pristine) {
      @for (error of control.errors | errorKeys; track error) {
        <mat-error>
          {{ messages[error] | translate }}
        </mat-error>
      }
    }
  </mat-form-field>
}
<div class="input-description">{{ description }}</div>
